import {
  UseProviderTeamsProps,
  UseProviderTeamsResponse
} from './useProviderTeams.types';
import useProviderTeamsV1 from './useProviderTeamsV1';
import useProviderTeamsPaginated from './useProviderTeamsPaginated';
import useIsGitSyncedTeamsPaginated from '../useIsGitSyncedTeamsPaginated';

const useProviderTeams = ({
  sensorAuthId,
  orgName
}: UseProviderTeamsProps): UseProviderTeamsResponse => {
  const isGitSyncedTeamsPaginated = useIsGitSyncedTeamsPaginated();
  const useProviderTeamsHook = isGitSyncedTeamsPaginated
    ? useProviderTeamsPaginated
    : useProviderTeamsV1;

  const { providerTeams, loadProviderTeams, isLoading } = useProviderTeamsHook({
    sensorAuthId,
    orgName
  });

  return {
    providerTeams,
    loadProviderTeams,
    isLoading
  };
};

export default useProviderTeams;
